export enum RenderLayerOrGroup {
    undefined = 0,
    layer = 1,
    group = 2
}